import { useState } from "react"
import { services } from "../data/services"
import Underline from "./Underline"

const Services = () => {
  // eslint-disable-next-line
  const [cards, setCards] = useState(services)

  return (
    <>
      <div className="bg-gray-100 pb-6">
        <h3 className="pt-10 text-center font-bold text-3xl mb-1 lg:text-5xl">
          Services
        </h3>
        <Underline />
      </div>
      <section className="bg-gray-100 pb-20 px-5 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 xl:px-40">
        {cards.map((card) => {
          const { id, image, title, desc } = card

          return (
            <article
              key={id}
              className="p-5 bg-white shadow-lg transition-all duration-300 hover:shadow-sm"
            >
              <img src={image} alt="" />
              <h4 className="font-bold mt-2 text-xl">{title}</h4>
              <p>{desc}</p>
            </article>
          )
        })}
      </section>
    </>
  )
}

export default Services
